import { render, staticRenderFns } from "./MainMenuLeaf.vue?vue&type=template&id=cc6a7b94&"
import script from "./MainMenuLeaf.vue?vue&type=script&lang=js&"
export * from "./MainMenuLeaf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports